import React, { PropsWithChildren } from "react";

import { HistoryTableRowItemProps } from "../../../@types/rldynamicanalysis";

const HistoryTableRowItem: React.FC<
  PropsWithChildren<HistoryTableRowItemProps>
> = ({ children, onClick }) => <td onClick={onClick}>{children}</td>;

export default HistoryTableRowItem;
